export const timeInStatusTiers = {
    NoThreshold: 0,
    WithinThreshold: 1,
    Approaching: 2,
    Breached: 3,
};

export const timeInStatusTierLabels = {
    [timeInStatusTiers.WithinThreshold]: 'Within Threshold',
    [timeInStatusTiers.Approaching]: 'Approaching Threshold',
    [timeInStatusTiers.Breached]: 'Threshold Breached',
    [timeInStatusTiers.NoThreshold]: 'No Threshold',
};

export const timeInStatusTierColors = {
    [timeInStatusTiers.NoThreshold]: '#757575',
    [timeInStatusTiers.WithinThreshold]: '#2e7d32',
    [timeInStatusTiers.Approaching]: '#b26a00',
    [timeInStatusTiers.Breached]: '#c62828',
};

export const timeInStatusTierBgColors = {
    [timeInStatusTiers.NoThreshold]: '#f5f5f5',
    [timeInStatusTiers.WithinThreshold]: '#e8f5e9',
    [timeInStatusTiers.Approaching]: '#fff4e5',
    [timeInStatusTiers.Breached]: '#fdecea',
};
